import { Component } from "react";
import PagePoint from "./index";

const {
  sendPagePoint,
  pagePointConfig: { regKey },
  EventType: { clickType, dblclickType, keydownType, focusType }
} = PagePoint;

interface IEProps {
  onClick?: any;
  onChange?: any;
  onKeyDown?: any;
  onFocus?: any;
  forwardedRef?: any;
  [propName: string]: any;
}

export default class PagePointEnhanced extends Component<IEProps> {
  composedHandler: any;
  origValue: any;

  constructor(props) {
    super(props);
    const {
      [regKey]: dataRegId,
      onClick,
      onChange,
      onKeyDown,
      onFocus,
      onDoubleClick
    } = this.props;
    let newClick, newChange, newKeyDown, newFocus, newDoubleClick;
    this.composedHandler = {};
    this.origValue = "";
    switch (props.compType) {
      case "Input":
        if (dataRegId) {
          newClick = e => {
            onClick && onClick(e);
            e.eventType = clickType;
            sendPagePoint(e, { origValue: this.origValue });
          };
          //  change 事件对于input而言基本和keydown重复，保留keydown
          //   newChange = e => {
          //     onChange && onChange(e);
          //     sendPagePoint(e.nativeEvent, { origValue: this.origValue });
          //   };
          newKeyDown = e => {
            onKeyDown && onKeyDown(e);
            e.nativeEvent.eventType = keydownType;
            sendPagePoint(e.nativeEvent, { origValue: this.origValue });
          };
          newFocus = e => {
            onFocus && onFocus(e);
            e.eventType = focusType;
            sendPagePoint(e);
            this.origValue = e.target && e.target.value;
          };

          this.composedHandler = {
            onClick: newClick,
            onFocus: newFocus,
            onKeyDown: newKeyDown
          };
        }
        break;
      case "InputNumber":
        if (dataRegId) {
          newClick = e => {
            onClick && onClick(e);
            e.eventType = clickType;
            sendPagePoint(e, { origValue: this.origValue });
          };
          // change 事件发送click
          newChange = value => {
            onChange && onChange(value);
            sendPagePoint({
              eventType: clickType,
              tagname: "InputNumber",
              value,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = value;
          };
          newKeyDown = e => {
            onKeyDown && onKeyDown(e);
            e.eventType = keydownType;
            sendPagePoint(e, { origValue: this.origValue });
          };
          newFocus = e => {
            onFocus && onFocus(e);
            e.eventType = focusType;
            sendPagePoint(e);
          };

          this.composedHandler = {
            onClick: newClick,
            onChange: newChange,
            onFocus: newFocus,
            onKeyDown: newKeyDown
          };
        }
        break;
      case "Button":
        if (dataRegId) {
          let clickTimeId;
          newClick = e => {
            onClick && onClick(e);
            clearTimeout(clickTimeId);
            const event = e.nativeEvent;
            clickTimeId = setTimeout(function() {
              event.eventType = clickType;
              sendPagePoint(event);
            }, 300);
          };
          newKeyDown = e => {
            onKeyDown && onKeyDown(e);
            e.eventType = keydownType;
            sendPagePoint(e);
          };
          newDoubleClick = e => {
            onDoubleClick && onDoubleClick(e);
            clearTimeout(clickTimeId);
            e.eventType = dblclickType;
            sendPagePoint(e);
          };
          this.composedHandler = {
            onClick: newClick,
            onKeyDown: newKeyDown,
            onDoubleClick: newDoubleClick
          };
        }
        break;
      case "Icon":
        if (dataRegId) {
          let count = 0;
          // doubleclick 无效, 由click 触发
          newClick = e => {
            onClick && onClick(e);
            count += 1;
            setTimeout(function() {
              if (count === 1) {
                sendPagePoint({
                  eventType: clickType,
                  [regKey]: dataRegId,
                  tagname: "icon"
                });
              } else if (count > 1) {
                sendPagePoint({
                  eventType: dblclickType,
                  [regKey]: dataRegId,
                  tagname: "icon"
                });
              }
              count = 0;
            }, 300);
          };
          this.composedHandler = {
            onClick: newClick
          };
        }
        break;
      case "Checkbox":
        if (dataRegId) {
          newClick = e => {
            onClick && onClick(e);
            e.eventType = clickType;
            sendPagePoint(e);
          };
          //   newChange = e => {
          //     onChange && onChange(e);
          //     sendFdxPagePoint(e.nativeEvent, {
          //       eventType: clickType,
          //       value: e.target.checked
          //     });
          //  };
          this.composedHandler = {
            onClick: newClick
          };
        }
        break;
      case "CheckboxGroup":
        if (dataRegId) {
          newChange = value => {
            onChange && onChange(value);
            const valueStr = JSON.stringify(value);
            sendPagePoint({
              eventType: clickType,
              tagname: "checkboxGroup",
              value: valueStr,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = valueStr;
          };
          this.composedHandler = {
            onChange: newChange
          };
        }
        break;
      case "Radio":
        if (dataRegId) {
          newClick = e => {
            onClick && onClick(e);
            e.eventType = clickType;
            sendPagePoint(e);
          };
          //   newChange = e => {
          //     onChange && onChange(e);
          //     sendFdxPagePoint(e.nativeEvent, {
          //       eventType: "change",
          //       value: e.target.checked
          //    });
          //  };
          this.composedHandler = {
            onClick: newClick
          };
        }
        break;
      case "RadioGroup":
        if (dataRegId) {
          newChange = e => {
            onChange && onChange(e);
            sendPagePoint({
              eventType: clickType,
              [regKey]: dataRegId,
              tagname: "radioGroup",
              value: e.target.value,
              origValue: this.origValue
            });
            this.origValue = e.target.value;
          };
          this.composedHandler = {
            onChange: newChange
          };
        }
        break;
      case "DatePicker":
      case "TimePicker":
      case "MonthPicker":
      case "RangePicker":
      case "WeekPicker":
        if (dataRegId) {
          // click,keydown无效,focus被触发两次
          // newFocus = (e) => {
          //     onFocus && onFocus(e);
          //     sendPagePoint(e);
          //     this.origValue = e.target && e.target.value
          // }
          newChange = (dateMomnet, dateString) => {
            onChange && onChange(dateMomnet, dateString);
            let dateStr = dateString;
            // rangepicker为数组
            if (Array.isArray(dateString)) {
              dateStr = JSON.stringify(dateString);
            }
            // change 发送 click
            sendPagePoint({
              eventType: clickType,
              tagname: "datetimePicker",
              value: dateStr,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = dateStr;
          };

          this.composedHandler = {
            onChange: newChange
          };
        }
        break;
      case "Select":
        if (dataRegId) {
          // click,keydown无效
          // change 发送 click
          newChange = (value, option) => {
            onChange && onChange(value, option);
            sendPagePoint({
              eventType: clickType,
              tagname: "select",
              value,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = value;
          };
          newFocus = e => {
            onFocus && onFocus(e);
            sendPagePoint({
              eventType: focusType,
              tagname: "select",
              [regKey]: dataRegId,
              value: this.origValue
            });
          };

          this.composedHandler = {
            onChange: newChange,
            onFocus: newFocus
          };
        }
        break;
      case "Modal":
        if (dataRegId) {
          const { onOk, onCancel } = this.props;
          let newOk, newCancel;
          newOk = e => {
            onOk && onOk(e);
            sendPagePoint({
              eventType: clickType,
              tagname: "modal",
              value: "ok",
              [regKey]: dataRegId
            });
          };
          newCancel = () => {
            onCancel && onCancel();
            sendPagePoint({
              eventType: clickType,
              tagname: "modal",
              value: "cancel",
              [regKey]: dataRegId
            });
          };

          this.composedHandler = {
            onOk: newOk,
            onCancel: newCancel
          };
        }
        break;
      case "Popconfirm":
        if (dataRegId) {
          const { onConfirm, onCancel } = this.props;
          let newConfirm, newCancel;
          newConfirm = e => {
            onConfirm && onConfirm(e);
            sendPagePoint({
              eventType: clickType,
              tagname: "popconfirm",
              value: "ok",
              [regKey]: dataRegId
            });
          };
          newCancel = () => {
            onCancel && onCancel();
            sendPagePoint({
              eventType: clickType,
              tagname: "popconfirm",
              value: "cancel",
              [regKey]: dataRegId
            });
          };

          this.composedHandler = {
            onConfirm: newConfirm,
            onCancel: newCancel
          };
        }
        break;
      //  TableSelect onchange为自定义，需在内部修改
      case "Table":
        if (dataRegId) {
          const { rowSelection, onRow } = this.props;
          if (rowSelection) {
            const { onChange } = rowSelection;
            newChange = (selectedRowKeys, selectedRows) => {
              onChange && onChange(selectedRowKeys, selectedRows);
              // change 发送click
              const rowKeys = JSON.stringify(selectedRowKeys);
              sendPagePoint({
                eventType: clickType,
                tagname: "table",
                value: rowKeys,
                // selectedRows: JSON.stringify(selectedRows),
                [regKey]: dataRegId,
                origValue: this.origValue
              });
              this.origValue = rowKeys;
            };
            this.composedHandler = {
              onChange: newChange
            };
          }
          const newOnRow = (record, index) => ({
            ...(onRow ? onRow(record, index) : {}),
            onClick: event => {
              if (onRow && onRow(record, index)["onClick"]) {
                onRow(record, index)["onClick"](event);
              }
              const {
                clientX,
                clientY,
                altKey,
                ctrlKey,
                metaKey,
                shiftKey
              } = event;
              sendPagePoint({
                eventType: clickType,
                tagname: "table",
                value: JSON.stringify(record),
                [regKey]: dataRegId,
                clientX,
                clientY,
                altKey,
                ctrlKey,
                metaKey,
                shiftKey
              });
            },
            onDoubleClick: event => {
              if (onRow && onRow(record, index)["onDoubleClick"]) {
                onRow(record, index)["onDoubleClick"](event);
              }
              const {
                clientX,
                clientY,
                altKey,
                ctrlKey,
                metaKey,
                shiftKey
              } = event;
              sendPagePoint({
                eventType: dblclickType,
                tagname: "table",
                value: JSON.stringify(record),
                [regKey]: dataRegId,
                clientX,
                clientY,
                altKey,
                ctrlKey,
                metaKey,
                shiftKey
              });
            }
          });
          this.composedHandler.onRow = newOnRow;
        }
        break;
      case "TreeSelect":
        if (dataRegId) {
          newChange = (value, label, extra) => {
            onChange && onChange(value, label, extra);
            // change 发送 click
            sendPagePoint({
              eventType: clickType,
              tagname: "treeSelect",
              value,
              label: JSON.stringify(label),
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = value;
          };

          this.composedHandler = {
            onChange: newChange
          };
        }
        break;
      case "Tree":
        if (dataRegId) {
          const newCheck = value => {
            const { onCheck } = this.props;
            const valueStr = JSON.stringify(value);
            onCheck && onCheck(value);
            // check 发送 click
            sendPagePoint({
              eventType: clickType,
              tagname: "Tree",
              value: valueStr,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = valueStr;
          };

          this.composedHandler = {
            onCheck: newCheck
          };
        }
        break;
      case "AutoComplete":
        //click keydown无效
        if (dataRegId) {
          // change 发送 click
          newChange = value => {
            onChange && onChange(value);
            sendPagePoint({
              eventType: clickType,
              tagname: "autocomplete",
              [regKey]: dataRegId,
              origValue: this.origValue,
              value
            });
            this.origValue = value;
          };
          //此处无参数
          newFocus = () => {
            onFocus && onFocus();
            sendPagePoint({
              eventType: focusType,
              tagname: "autocomplete",
              [regKey]: dataRegId
            });
          };

          this.composedHandler = {
            onChange: newChange,
            onFocus: newFocus
          };
        }
        break;
      default:
        break;
    }
  }

  render() {
    return this.props.render(this.composedHandler);
  }
}



// WEBPACK FOOTER //
// ./src/components/page-point/pagePointEnhanced.tsx